/**
 * Helpers compartidos para el módulo Flota (mantenimiento de embarcaciones).
 */

export const API_BASE = process.env.REACT_APP_API_URL || 'https://turismo.nara.chat/api';

export function getEmpresaId() {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return u.company_id || u.empresa_id || '1';
  } catch { return '1'; }
}

export function getUserRole() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}').role || 'miembro';
  } catch { return 'miembro'; }
}

export function getAuthHeaders() {
  const t = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(t ? { Authorization: `Bearer ${t}` } : {}) };
}

export function fmtFecha(s) {
  if (!s) return '—';
  try { return new Date(s).toLocaleDateString('es-CO', { day: 'numeric', month: 'short', year: 'numeric' }); }
  catch { return s; }
}

export function fmtFechaCorta(s) {
  if (!s) return '—';
  try { return new Date(s).toLocaleDateString('es-CO', { day: 'numeric', month: 'short' }); }
  catch { return s; }
}

export function fmtMoney(n) {
  if (n == null) return '—';
  return '$' + new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0 }).format(Number(n));
}

export const CATEGORIAS = [
  { value: 'motor',         label: 'Motor',         color: '#0ea5e9' },
  { value: 'casco',         label: 'Casco',         color: '#0d9488' },
  { value: 'electricidad',  label: 'Electricidad',  color: '#f59e0b' },
  { value: 'legal',         label: 'Legal/DIMAR',   color: '#dc2626' },
  { value: 'general',       label: 'General',       color: '#64748b' },
];

export const TIPOS_EVENTO = [
  { value: 'preventivo', label: 'Preventivo' },
  { value: 'correctivo', label: 'Correctivo' },
  { value: 'legal',      label: 'Legal' },
];

export const ESTADOS = {
  programado: { color: '#0ea5e9', bg: '#dbeafe', label: 'Programado' },
  en_curso:   { color: '#f59e0b', bg: '#fef3c7', label: 'En curso' },
  completado: { color: '#16a34a', bg: '#dcfce7', label: 'Completado' },
  vencido:    { color: '#dc2626', bg: '#fee2e2', label: 'Vencido' },
  saltado:    { color: '#64748b', bg: '#e2e8f0', label: 'Saltado' },
};

/** Días entre hoy y la fecha programada (negativo si vencido). */
export function diasParaVencer(fechaProgramada) {
  if (!fechaProgramada) return null;
  const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
  const f = new Date(fechaProgramada); f.setHours(0, 0, 0, 0);
  return Math.round((f - hoy) / 86400000);
}
